import {useDictionary} from '@adamlip/okeoke.client';
import useBasket from 'hooks/useBasket';

export default function Delivery() {
	const {getValue} = useDictionary();
	const {deliveryCost} = useBasket();

	if (deliveryCost == null || deliveryCost === 0) return null;

	return (
		<div className='w-full flex flex-row justify-between items-center'>
			<div className='text-sm opacity-70'>{`${getValue('app_v2_delivery_cost')}`}</div>
			<div className='text-sm opacity-70'>{deliveryCost} Ft</div>
		</div>
	);
}
